export default __webpack_public_path__ + "chevron.941692c52804790d1b4c7fc1b688bb64.svg";